import { Component, OnInit, Inject } from '@angular/core';
import { FaqService } from 'src/app/shared/services/faq.service';
//import { NotificationService } from 'src/app/shared/services/notification.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
//import { ToastrService } from 'ngx-toastr';
import { IssueService } from 'src/app/shared/services/issue.service';
import { IssueTrackService } from 'src/app/shared/services/issue-track.service';
import { FaQFileModel, IssueFileModel, IssueTrackDetailModel } from 'src/app/shared/models/issue.model';
//import { FormGroup } from '@angular/forms';
//import { FaQModel } from 'src/app/shared/models/faq.model';
//import { prepareEventListenerParameters } from '@angular/compiler/src/render3/view/template';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-faq-edit',
  templateUrl: './faq-edit.component.html',
  styleUrls: ['./faq-edit.component.css']
})
export class FaqEditComponent implements OnInit {
  dialogData :any;
  ifiles : IssueFileModel []; // issue files
  sfiles : IssueFileModel []; // solution files
  isNew : boolean;
  constructor(

    private issueService: IssueService,
    private solutionService: IssueTrackService,
    public service: FaqService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
   // private notificationService: NotificationService,
    public dialogRef: MatDialogRef<FaqEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data : any) {

      console.log("constructor : FaqEditComponent");
      this.dialogData = data;
      this.service.initializeFormGroup();
    }

  ngOnInit() {

    console.log("ngOnInit : FaqEditComponent");

    if(this.dialogData)
    {
      if(this.dialogData.issue)
      {
        this.service.form.controls['issue'].setValue(this.dialogData.issue.issue);

        this.solutionService.findDataByIssue(this.dialogData.issue.issueId).subscribe(
          res => {
            this.issueService.getIssueFileList(this.dialogData.issue.issueId).subscribe(
              res=>{

                console.log("getIssueFileList");
                this.ifiles = res as IssueFileModel[];
              });
            //this.thisData = res as IssueTrackModel [];
            var list = res as IssueTrackDetailModel [];
            var solution = "";
            if(!this.sfiles) this.sfiles = new Array<IssueFileModel>();
            list.forEach(element => {
              solution += element.solution + "\n\n";

              this.solutionService.getIssueFileList(element.trackId).subscribe(
                res=>{
                  var files = res as IssueFileModel[];
                  files.forEach(item => {
                      this.sfiles.push(item);
                  });
                });
            });

            this.service.form.controls['solution'].setValue(solution);
          },
          err =>{
            console.log(err);
          }
        );
      }
      else{
        if(this.dialogData.id) //update
        {
            this.service.getDetail(this.dialogData.id).subscribe(
              res=>{
                 this.service.populateForm(res);
                 this.service.getFaqFileList(this.dialogData.id).subscribe(
                  res=>{
                    var files = res as FaQFileModel[];
                    console.log(files.length);
                    if(!this.ifiles) this.ifiles = new Array<IssueFileModel>();
                    if(!this.sfiles) this.sfiles = new Array<IssueFileModel>();

                    files.forEach(item => {
                      if(item.type == '0')
                        this.ifiles.push(item);
                      else
                        this.sfiles.push(item);
                    });


                  },
                  err=>{}
                );
              },
              err=>{

              }

            );
        }
        else{

        }

      }
    }
  }
  onClose() {

    this.service.form.reset();
    this.service.initializeFormGroup();
    this.dialogRef.close(false);
  }

  onSubmit() {
    console.log("FaQ onSubmit");
  //  var error;
  //  var result = false;
    if (!this.service.form.valid) {
      ////this.toastr.error("Pleae input all the mendatory items.", "Invalid");
      this.gnotify.showSnackBar('Invalid', 'Pleae input all the mendatory items.', "error");
      return;
    }

    if (this.ifiles)
    {
      this.service.form.value.ifiles = new Array<string>();
        for(var item of this.ifiles)
        {
          this.service.form.value.ifiles.push(item.fileId);
        }
    }

    if (this.sfiles)
    {
      this.service.form.value.sfiles = new Array<string>();
        for(var item of this.sfiles)
        {
          this.service.form.value.sfiles.push(item.fileId);
        }
    }


    if (!this.service.form.get('faqId').value){
      this.service.insertData(this.service.form.value).subscribe(
        res=>{
          ////this.toastr.success("Submit successfuly", "FaQ Create");
          this.gnotify.showSnackBar('FaQ Create', 'Submit successfuly', "success");
          this.dialogData.result = true;
          this.onClose();

        },
        err=>{
        //      console.log(err);
        ////  this.toastr.error("Failed to Submit", "Customer Create");
          this.gnotify.showSnackBar('FaQ Create', 'Failed to Submit', "error");
        }
        );
    }
    else{
      console.log("updateData");

      this.service.updateData(this.service.form.value).subscribe(
        res=>{
          ////this.toastr.success("Submit successfuly", "FaQ Modify");
          this.gnotify.showSnackBar('FaQ Modify', 'Submit successfuly', "success");
          this.dialogData.result = true;
          this.onClose();
        },
        err=>{
          console.log(err);
       ////   this.toastr.error("Failed to Submit", "FaQ Modify");
          this.gnotify.showSnackBar('FaQ Modify', 'Failed to Submit', "error");
          }
        );

    }

  }

  onDeleteFile(fileId, type)
  {
      if(!confirm("Are you sure to delete this image?")) return;
      if(type == 0) // issue
        this.ifiles = this.ifiles.filter(item => item.fileId != fileId);
      else // solution
        this.sfiles = this.sfiles.filter(item => item.fileId != fileId);

  }

  public uploadFinishedForIssue = (event) => {

    if(event)
    {
      if(!this.ifiles) this.ifiles = new Array<IssueFileModel>();
       this.ifiles.push( IssueFileModel.convertFromUploadedFile(event));
    }

  }

  public uploadFinishedForSolution = (event) => {

    if(event)
    {
      if(!this.sfiles) this.sfiles = new Array<IssueFileModel>();
       this.sfiles.push( IssueFileModel.convertFromUploadedFile(event));
    }

  }
}
